import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { ListingSvg } from './ListingSvg'

export const EaListingIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={ListingSvg} {...props} />
)
